//#region Styles
import { Row, TitleSection } from "components/styles";
//#endregion
//#region Components
import CustomTableList from "components/CustomTableList/CustomTableList";
import DateListItemOfWeek from "../DateListItemOfWeek/DateListItemOfWeek";
import NotificationNoContent from "components/NotificationNoContent/NotificationNoContent";
//#endregion
//#region Icons
import LocationIcon2 from "icons/LocationIcon2";
import TimerIcon from "icons/TimerIcon";
//#endregion

const HEADERS_TABLE_LIST_BASE = [
	{ title: "Fecha" },
	{ title: "Hora", icon: <TimerIcon /> },
	{ title: "Programación", icon: <LocationIcon2 /> },
];
const HEADERS_TABLE_LIST_ADMIN = [
	...HEADERS_TABLE_LIST_BASE,
	{ title: "Editar" },
	{ title: "Eliminar" },
];
const HEADERS_TABLE_LIST_TEACHER = [
	...HEADERS_TABLE_LIST_BASE,
	{ title: "Lista de inscritos" },
];

const DateListOfWeek = ({
	isTeacherUser,
	askIfItWillBeUpdated,
	askIfItWillBeDeleted,
	dateList = [],
	title,
	fillEventDataToAttendance,
}) => {
	return (
		<>
			<Row width="100%">
				<TitleSection width="50%">{title}</TitleSection>
			</Row>
			{dateList.length > 0 ? (
				<CustomTableList
					minWidth="1140px"
					headers={
						isTeacherUser
							? HEADERS_TABLE_LIST_TEACHER
							: HEADERS_TABLE_LIST_ADMIN
					}
				>
					{dateList.map((dateItem, idx) => (
						<DateListItemOfWeek
							key={idx}
							{...dateItem}
							isTeacherUser={isTeacherUser}
							askIfItWillBeUpdated={askIfItWillBeUpdated}
							askIfItWillBeDeleted={askIfItWillBeDeleted}
							fillEventDataToAttendance={
								fillEventDataToAttendance
							}
						/>
					))}
				</CustomTableList>
			) : (
				<NotificationNoContent
					variant="secondary"
					direction="row"
					description="En esta semana no tienes días del evento programados."
				/>
			)}
		</>
	);
};

export default DateListOfWeek;
